import { CampaignChange, CampaignChangesData } from "./reducer";

export const TransformCampaignChangesResponse = (
  response: CampaignChangesData
): CampaignChange[] => {
  let campaignChanges: CampaignChange[] = [];

  response.campaignChanges.forEach((c) => {
    campaignChanges.push({
      appIcon: c.appIcon,
      appTitle: c.appTitle,
      campaignId: c.campaignId,
      campaignName: c.campaignName,
      field: c.field,
      newValue: c.newValue,
      oldValue: c.oldValue,
      partnerName: c.partnerName,
      createdAt: c.createdAt,
    });
  });

  return campaignChanges;
};

export interface OverviewResponseGraphRow {
  date: Date;
  installs: number;
  spend: number;
}

export interface OverviewResponseCampaign {
  id: string;
  name: string;
  mmp: string | null;
  appName: string;
  appId: string;
  iconUrl: string;
  playStoreUrl: string;
  countries: string[] | null;
  status: boolean;
  isDirect: boolean;
  installs: number;
  clicks: number;
  spend: number;

  genders: number[] | null;
  minAge: number | null;
  maxAge: number | null;
  minApiLevel: number | null;
  maxApiLevel: number | null;
  bid: number;
  biddingType: string;
  dailyBudgetCap: number;
  clickUrl: string;
}

export interface OverviewResponse {
  from: Date;
  until: Date;
  totalInstalls: number;
  totalSpend: number;
  graphRows: OverviewResponseGraphRow[];
  campaigns: OverviewResponseCampaign[];
}
